<template>
  <v-container
    dark
    fluid
    class="coming-soon">
    <!-- META-DATA -->
    <vue-headful
      :title="`Coming Soon${this.$store.state.app.meta.titleSuffix}`"
      :description="this.$store.state.app.meta.description" />

    <v-card
      dark
      color="transparent"
      class="body">
      <m-h-logo width="100" />
      <h1 class="body__headline">Coming Soon</h1>

      <v-fade-transition
        appear
        mode="out-in">
        <div
          v-if="submitStatus==='error' || submitStatus==='default'"
          class="register">
          <p>Sign up below and we'll email you when we open:</p>

          <form
            v-if="submitStatus!=='error'"
            class="email-form"
            @submit.prevent="registerEmail">
            <input
              id="email"
              v-model="emailAddress"
              type="email"
              class="email-form__email-input"
              placeholder="Your Email Address">
            <button
              class="email-form__submit-button"
              type="submit">
              Sign Me Up!
            </button>
          </form>
          <p
            v-if="submitStatus==='error'"
            class="error-message">
            Server error: please try again later
          </p>
        </div>

        <div
          v-if="submitStatus==='loading'"
          class="register register--loading">
          <v-progress-circular
            size="50"
            indeterminate
            color="secondary" />
        </div>

        <div
          v-if="submitStatus==='success'"
          class="register register--success">
          <h3 class="success-message__header">Success!</h3>
          <p class="success-message">
            Thank you! We'll be sure to let you know as soon as we've opened!
          </p>
        </div>
      </v-fade-transition>

      <div class="social">
        <p>Or connect with us here:</p>
        <div class="social__icon-row">
          <v-btn
            href="https://www.instagram.com/memerhats/"
            outline
            icon
            large
            color="primary"
            class="social__link">
            <icon-instagram />
          </v-btn>
          <v-btn
            href="https://www.minds.com/memerhats/"
            outline
            icon
            large
            color="primary"
            class="social__link">
            <icon-minds />
          </v-btn>
        </div>
      </div>
    </v-card>

    <v-footer
      dark
      color="transparent"
      class="footer">
      Copyright

      <v-dialog
        v-model="passwordDialog"
        width="300">
        <template v-slot:activator="{ on }">
          <span
            class="copyright"
            v-on="on">&#169;</span>
        </template>

        <v-card>
          <v-card-text>
            <v-alert
              v-if="passwordLockout"
              :value="true"
              type="error">
              Access Denied
            </v-alert>
            <v-form
              v-else
              ref="passwordForm"
              @submit.prevent="submitPassword">
              <v-text-field
                v-model="passwordInput"
                type="password"
                label="Enter Password Here"
                required />
              <v-btn
                block
                flat
                color="primary"
                type="submit">
                submit
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>

      2020 MemerHats Ltd. All Rights Reserved.
    </v-footer>
  </v-container>
</template>

<script>
import MHLogo from '../components/MHLogo.vue';
import IconInstagram from '../components/icons/IconInstagram.vue';
import IconMinds from '../components/icons/IconMinds.vue';

import api from '../utils/api';

export default {
  name: 'ComingSoon',
  components: {
    MHLogo,
    IconInstagram,
    IconMinds,
  },
  data() {
    return {
      emailAddress: '',
      date: new Date(),
      submitStatus: 'default',

      passwordDialog: false,
      passwordLockout: false,
      password: 'Mango300',
      passwordInput: '',
    };
  },
  methods: {
    registerEmail() {
      this.submitStatus = 'loading';
      const emailData = {
        emailAddress: this.emailAddress,
        date: this.date,
      };
      api
        .postData('/storefront/mailing_list/', emailData)
        .then(() => {
          this.submitStatus = 'success';
        })
        .catch(() => {
          this.submitStatus = 'error';
        });
    },
    submitPassword() {
      if (this.passwordInput === this.password) {
        this.goToHome();
      } else {
        this.passwordLockout = true;
        this.$refs.passwordForm.reset();
      }
    },
    goToHome() {
      this.$store.dispatch('auth/grantComingSoonAccess').then(() => {
        this.$router.push({ path: '/' });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@require('../stylus/base')

.coming-soon
  position: relative
  display: flex
  flex-flow: column nowrap
  align-items: center
  justify-content: center
  height: 100%
  padding: $base-padding*2
  background-color: $black
  background-image: url('../assets/images/landing-teaser.jpg')
  background-size: cover
  background-position: center center
  background-repeat: no-repeat no-repeat

.body
  display: flex
  flex-flow: column nowrap
  align-items: center
  opacity: .9

  &__headline
    padding: $base-padding
    text-align: center
    text-transform: uppercase

.register
  display: flex
  flex-flow: column nowrap
  align-items: center
  justify-content: center
  height: 8rem
  text-align: center

.email-form
  display: flex
  flex-flow: row nowrap
  align-items: stretch
  align-content: stretch
  justify-content: flex-start
  padding: $base-padding*.5 0 $base-padding*2 0

  &__email-input
    display: flex
    flex-basis: 1
    flex-grow: 0
    flex-shrink: 1
    width: 100%
    max-width: 100%
    padding: $base-padding*.5 $base-padding
    border-radius: $base-border-radius 0 0 $base-border-radius
    border: none
    color: $primary
    background-color: $secondary
    transition: $base-transition
    &:focus
      outline: none
      color: $secondary
      background-color: $primary

  &__submit-button
    display: flex
    align-items: center
    justify-content: space-around
    flex-basis: 8rem
    flex-grow: 1
    flex-shrink: 1
    font-weight: 400
    line-height: 1.6em
    min-width: 8em
    height: auto
    padding: $base-padding*.5 $base-padding
    border-radius: 0 $base-border-radius $base-border-radius 0
    cursor: pointer
    text-align: center
    text-decoration: none
    text-transform: uppercase
    white-space: nowrap
    color: $primary
    background-color: $secondary
    border: none
    transition: $base-transition
    &:hover
      color: $secondary
      background-color: $primary

.success-message
  text-align: center

.error-message
    background-color: $error
    padding: $base-padding
    border-radius: $base-border-radius

.social
  text-align: center

  &__link
    color: $secondary
    &:hover
      color: $primary

.footer
  position: absolute
  justify-content: center
  bottom: 0
  width: 100%
  text-align: center
  text-transform: uppercase
  font-size: .5rem
  opacity: .45

.copyright
  padding: 0 .3em

</style>
